import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, AuthGuardChild } from './core/auth';
import { ErrorPageComponent } from './content/pages/error-page/error-page.component';

const routes: Routes = [
  {
    path: 'pages',
    canActivateChild: [AuthGuardChild],
    loadChildren: () => import('./content/pages/pages.module').then(p => p.PagesModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./content/pages/login/login.module').then(l => l.LoginModule)
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./content/pages/home/home.module').then(h => h.HomeModule)
  },
  { path: '404', component: ErrorPageComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '?', redirectTo: 'home', pathMatch: 'full' },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
